// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__MpC0P","item":"PaymentsMobile_item__2rUGH","label":"PaymentsMobile_label__1h6o8","amount":"PaymentsMobile_amount__2hdk7"};